import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dialog-folder__title" }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  class: "file-tree-body-container",
  style: {"overflow":"auto"}
}
const _hoisted_4 = { class: "tree-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "custom_tree_node"
}
const _hoisted_6 = { class: "file_desc" }
const _hoisted_7 = { class: "file_title" }
const _hoisted_8 = { class: "control_action" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "custom_tree_node"
}
const _hoisted_11 = { class: "file_desc" }
const _hoisted_12 = { class: "file_title" }
const _hoisted_13 = { class: "file-tree-btn-container" }
const _hoisted_14 = { class: "file-tree-btn__normal" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.pathSelector.visibleSelectFolder.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pathSelector.visibleSelectFolder.value) = $event)),
    class: "dialog-folder",
    "append-to-body": "",
    onClose: _ctx.cancel,
    width: "450px",
    "show-close": false
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "dialog-folder__left__tip",
          title: _ctx.pathSelector.pathSelectorTitle
        }, _toDisplayString(_ctx.pathSelector.pathSelectorTitle || '选择保存位置'), 9, _hoisted_2),
        _createElementVNode("i", {
          class: "icomoon-close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: _normalizeClass(["file-tree-btn__new", ['createFileBtn', _ctx.disableCreateNode && !_ctx.rootNode ? 'disabled' : '']]),
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleCreateNode && _ctx.handleCreateNode(...args)), ["stop"]))
        }, " 新建文件夹 ", 2),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)), ["stop"])),
            class: _normalizeClass(["btn-ok", [_ctx.isEdit || !_ctx.rootNode ? 'disabled' : '']]),
            disabled: _ctx.isEdit || !_ctx.rootNode
          }, " 确定 ", 10, _hoisted_15),
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)), ["stop"])),
            class: "btn-cancel"
          }, " 取消 ")
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.pathSelector.visibleSelectFolder.value)
            ? (_openBlock(), _createBlock(_component_el_tree, {
                key: 0,
                onNodeClick: _ctx.handleNodeClick,
                onNodeCollapse: _ctx.handelCollapse,
                onNodeExpand: _ctx.handelExpand,
                "default-expanded-keys": _ctx.defaultExpandedKeys,
                props: _ctx.defaultProps,
                load: _ctx.loadNode,
                "highlight-current": true,
                "empty-text": _ctx.emptyText,
                "node-key": "id",
                ref: "tree",
                lazy: ""
              }, {
                default: _withCtx(({ node, data }) => [
                  (data.isEdit)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", {
                            class: "file_icon",
                            style: _normalizeStyle({ backgroundImage: 'url(' + data.icon + ')' })
                          }, null, 4),
                          _createElementVNode("a", _hoisted_7, [
                            _createVNode(_component_el_input, {
                              modelValue: data.title,
                              "onUpdate:modelValue": ($event: any) => ((data.title) = $event),
                              autofocus: "",
                              size: "mini",
                              ref: 'slotTreeInput' + data.id
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("span", _hoisted_8, [
                            _createElementVNode("i", {
                              class: "confirm_icon",
                              style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.icons.saveIcon + ')' }),
                              onClick: _withModifiers(($event: any) => (_ctx.handleInput(node, data)), ["stop"])
                            }, null, 12, _hoisted_9),
                            _createElementVNode("i", {
                              class: "del_icon",
                              style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.icons.delIcon + ')' }),
                              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handelDelItem && _ctx.handelDelItem(...args)), ["stop"]))
                            }, null, 4)
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", {
                            class: "file_icon",
                            style: _normalizeStyle({ backgroundImage: 'url(' + data.icon + ')' })
                          }, null, 4),
                          _createElementVNode("a", _hoisted_12, _toDisplayString(node.label), 1)
                        ])
                      ]))
                ]),
                _: 1
              }, 8, ["onNodeClick", "onNodeCollapse", "onNodeExpand", "default-expanded-keys", "props", "load", "empty-text"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
}